import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Flex, Text } from '../components/base-components';
import { ReactComponent as Logo } from '../logo.svg';

export function AdminLoginPage() {
  const [searchParams] = useSearchParams();
  const { setAdminSession } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const accessToken = searchParams.get('access');
    const refreshToken = searchParams.get('refresh');
    const userEmail = searchParams.get('user');

    if (!accessToken || !refreshToken) {
      setError('Missing authentication tokens. Please try again from the admin panel.');
      return;
    }

    // Set admin session with the provided tokens
    setAdminSession(accessToken, refreshToken, userEmail || '');

    // Clean the URL and redirect
    setTimeout(() => {
      navigate('/notifications', { replace: true });
    }, 500);
  }, [searchParams, setAdminSession, navigate]);

  if (error) {
    return (
      <Flex
        direction="col"
        justify="center"
        align="center"
        minHeight="screen"
        bg="#0a0a0a"
        textColor="white"
        gap={6}
        px={4}
      >
        <Logo style={{ width: '80px', height: '80px', opacity: 0.3 }} />
        <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center">
          <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <Text variant="title" color="error">{error}</Text>
      </Flex>
    );
  }

  return (
    <Flex
      direction="col"
      justify="center"
      align="center"
      minHeight="screen"
      bg="#0a0a0a"
      textColor="white"
      gap={6}
    >
      <Logo style={{ width: '80px', height: '80px', animation: 'pulse 2s ease-in-out infinite' }} />
      <Text variant="title">Signing in as user...</Text>
      <div className="w-8 h-8 border-2 border-white/30 border-t-[#3b82f6] rounded-full animate-spin" />
    </Flex>
  );
}
